import { Classifier } from '../../generated/model/models';

export enum ClassifiersTypes {
  LegalForm = 'legalForm',
  Status = 'status',
  OwnershipType = 'ownershipType',
  RelationType = 'relationType',
  Currency = 'currency',
  DbVersions = 'dbVersions',
  AccountingStandard = 'accountingStandard',
  AccountingStandardType = 'accountingStandardType',
  RegionAndCountry = 'regionAndCountry',
  RegionAndCountryFull = 'regionAndCountryFull',
  Nace = 'nace',
  Sic = 'sic',
  ProfitAndLoss = 'profitAndLoss',
  BalanceData = 'balanceData',
  CompanyReportFields = 'companyReportFields',
  ContactInfoAvailability = 'contactInfoAvailability',
  AccountConsolidation = 'accountConsolidation',
  Dataset = 'dataset',
  StaticCurrency = 'staticCurrency',
}

export type Classifiers = {
  [ClassifiersTypes.LegalForm]: Classifier[];
  [ClassifiersTypes.Status]: Classifier[];
  [ClassifiersTypes.OwnershipType]: Classifier[];
  [ClassifiersTypes.RelationType]: Classifier[];
  [ClassifiersTypes.Currency]: Classifier[];
  [ClassifiersTypes.AccountingStandard]: Classifier[];
  [ClassifiersTypes.AccountingStandardType]: Classifier[];
  [ClassifiersTypes.DbVersions]: Classifier[];
  [ClassifiersTypes.RegionAndCountry]: Classifier[];
  [ClassifiersTypes.RegionAndCountryFull]: Classifier[];
  [ClassifiersTypes.Nace]: Classifier[];
  [ClassifiersTypes.Sic]: Classifier[];
  [ClassifiersTypes.ProfitAndLoss]: Classifier[];
  [ClassifiersTypes.BalanceData]: Classifier[];
  [ClassifiersTypes.CompanyReportFields]: Classifier[];
  [ClassifiersTypes.ContactInfoAvailability]: Classifier[];
  [ClassifiersTypes.AccountConsolidation]: Classifier[];
  [ClassifiersTypes.Dataset]: Classifier[];
  [ClassifiersTypes.StaticCurrency]: Classifier[];
};

export type ClassifiersProviderProps = {
  classifiers?: Classifiers;
  children: React.ReactNode;
};
